import styled, { css, keyframes } from 'styled-components';

export const scaleUpHorizontal = keyframes`
    0% { 
      visibility: visible;
      transform: scaleX(0.1); 
    }
  100% { 
      visibility: visible;
      transform: scaleX(1);
    }
`;

export const Main = styled.main`
  ${props =>
    props.transparent &&
    !props.fixed &&
    css`
      margin-top: -64px;
    `};
  ${props =>
    props.isMobile &&
    css`
      height: 100%;
    `};
`;

/* -------------------------------------
                HEADER
 ------------------------------------- */
export const StyledHeader = styled.header`
  top: 0;
  left: 0;
  z-index: 9999;
  color: #fff;
  ${({ theme }) => css`
    @media (max-width: ${theme.breakpoints.md}px) {
      min-width: 1200px;
    }
    @media (min-width: ${theme.breakpoints.md + 1}px) {
      width: 100%;
    }
  `}
  & > .header-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    ${props =>
      props.isMobile
        ? css`
            width: 100%;
            height: 54px;
          `
        : css`
            width: 100%;
            /* padding: ${({ theme }) => `0 ${theme.spacing(14)}`}; */
            height: 104px;
          `};
  }
  & .gnb-upload-btn.focused {
    border-color: ${({ theme }) => theme.palette.channelWhite};
    background-color: ${({ theme }) => theme.palette.secondaryBlue};
  }
  & .gnb-select-language {
    ${props =>
      props.isMobile &&
      css`
        padding-right: ${({ theme }) => theme.spacing(4)};
      `};
  }
  ${props =>
    props.transparent && props.isSticky
      ? css`
          position: absolute;
          background: 'transparent';
        `
      : css`
          position: sticky;
          position: -webkit-sticky;
          background-color: ${props => (props.backgroundColor ? props.theme.palette[props.backgroundColor] : props.theme.palette.darkgray)};
        `}
`;

export const LogoDiv = styled.div`
  display: flex;
  & img {
    cursor: pointer;
  }
  ${props =>
    props.isMobile &&
    css`
      padding: 0 16px;
      & img {
        height: 12px;
      }
    `}
`;

export const Divider = styled.hr`
  border: 0;
  border-left: 1px solid #ddd;
  margin: ${({ theme }) => theme.spacing(1.25, 4)};
  user-select: none;
`;

export const MenuDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-left: ${props => props.theme.spacing(28)};
  padding-right: ${props => props.theme.spacing(6)};
`;

/* -------------------------------------
                FOOTER
 ------------------------------------- */
export const StyledFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5.5em 3.5em;
  background-color: ${props => props.theme.palette.darkgray};
`;

export const CompanyInfoDiv = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 2em;
  & > img {
    width: 162px;
    margin-bottom: 1em;
    cursor: pointer;
  }
`;

export const CompanyInfoDiv2 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 2em;
  & > img {
    width: 162px;
    margin-bottom: 1em;
    cursor: pointer;
  }
`;

export const SnsContainer = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 16px 0 1.3em 0;
  padding: 0;
  list-style: none;
  & > li {
    margin-right: 8px;
  }
`;

export const TermsDiv = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  & > p {
    display: inline-block;
    margin: 0.7em 0;
    color: ${props => props.theme.palette.white};
    &:last-of-type {
      font-weight: 700;
      text-decoration: underline;
    }
  }
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const TermsDiv2 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
  width: 200px;
  & > p {
    display: inline-block;
    margin: 0.7em 0;
    color: ${props => props.theme.palette.white};
    &.highlighted {
      font-weight: 700;
      text-decoration: underline;
    }
  }
`;
